import { Routes } from '@angular/router';
import { authenticationGuard, featureFlagGuard } from '@core/guards';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/inmersion/inmersion.component').then((m) => m.Inmersion),
    children: [
      /**
       * Home de Inmersion. Debe declararse ANTES del `loadChildren` de landings,
       * que tambien ocupa el path vacio, y con `pathMatch: 'full'` para que
       * `topten`, `login` y `forgot` sigan resolviendo contra landings.
       */
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./features/home/home.component').then((m) => m.Home),
      },
      /** Ruta historica del home: se conserva como redireccion para no romper enlaces. */
      {
        path: 'home',
        redirectTo: '',
        pathMatch: 'full',
      },
      {
        path: 'realidad-virtual',
        loadComponent: () =>
          import('./features/virtual-reality/vr-library.component').then((m) => m.VrLibrary),
      },
      {
        path: '',
        loadChildren: () =>
          import('./features/landings/landings.routes').then((m) => m.landingsRoutes),
      },
      {
        path: 'cities',
        loadChildren: () => import('./features/cities/cities.routes').then((m) => m.citiesRoutes),
      },
      {
        path: 'routes',
        loadChildren: () => import('./features/routes/routes.routes').then((m) => m.routesRoutes),
      },
      {
        path: 'weathers',
        canMatch: [featureFlagGuard],
        data: { feature: 'weathers' },
        loadChildren: () => import('./features/routes/routes.routes').then((m) => m.routesRoutes),
      },
      {
        path: 'geomarker',
        loadChildren: () =>
          import('./features/geomarkers/geomarkers.routes').then((m) => m.geomarkersRoutes),
      },
      {
        path: 'contact',
        loadComponent: () => import('./features/contact/contact.component').then((m) => m.Contact),
      },
      {
        path: 'pages/404',
        loadComponent: () =>
          import('./features/not-found/not-found.component').then((m) => m.NotFound),
      },
      {
        path: 'pages/privacy-policies',
        loadChildren: () =>
          import('./features/privacy-policies/privacy-policies.routes').then(
            (m) => m.privacyRoutes,
          ),
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./features/user/pages/profile/profile.component').then((m) => m.Profile),
        canActivate: [authenticationGuard],
      },
      {
        path: 'search',
        loadComponent: () => import('./features/search/search.component').then((m) => m.Search),
      },
      {
        path: 'booking',
        loadChildren: () => import('./modules/booking/booking.routes').then((m) => m.bookingRoutes),
      },
      {
        path: 'register-company',
        loadComponent: () =>
          import('./modules/user/register-company/register-company.component').then(
            (m) => m.RegisterCompanyComponent,
          ),
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./modules/dashboard/dashboard.routes').then((m) => m.dashboardRoutes),
      },
      {
        path: 'checkout',
        loadComponent: () =>
          import('./modules/checkout/checkout.component').then((m) => m.CheckoutComponent),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'pages/404',
  },
];
